import React from 'react';

import cn from '@/lib/clsxm';

import { CardMedia } from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Props from '@/components/shared/components/cards/readySite/media/type';

import imagesList from '@/constant/images-list';
import localization from '@/constant/localization';
import ImageModel from '@/models/image.model';

export default function Media({ isHovered, cover, promoted = false, slug }: Props) {
  const srcValue =
    cover && typeof cover === 'string'
      ? cover
      : (cover as ImageModel)?.publicLink || imagesList.images.demoCover;
  return (
    <Container className='relative h-full w-full overflow-hidden'>
      <a className='text-md line-clamp-1 text-[#F4F5F6]' href={`/web/${slug}`}>
        <CardMedia
          className={cn(
            'top-0 left-0 h-full w-full object-cover object-top transition-all duration-[2000ms] ease-in-out',
            isHovered && 'md:object-bottom',
          )}
          fill
          src={srcValue}
          alt={(cover as ImageModel)?.title || 'demo cover'}
        />
      </a>
      {promoted && (
        <Container
          center
          className='absolute top-[14px] left-[15px] h-[29px] w-[68px] gap-[5px] rounded-md bg-white shadow-[0px_5px_4px_-2px_#00000040]'
        >
          <XImage
            src={imagesList.icons.promote}
            alt={localization.zhaket}
            width={12}
            height={11}
            className='-mt-0.5'
          />
          <Text className='text-[11px] font-bold text-[#81CF33]'>{localization.promote}</Text>
        </Container>
      )}
    </Container>
  );
}
